export { default } from './GIGRActivation.jsx';
